import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Label = styled.label`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--auth-label);
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input<{ $hasToggle?: boolean; $hasError?: boolean }>`
  width: 100%;
  font-family: inherit;
  font-size: 15px;
  color: var(--auth-text-primary);
  background: #fff;
  border: 1px solid
    ${({ $hasError }) => ($hasError ? "var(--auth-accent)" : "var(--auth-input-border)")};
  border-radius: 12px;
  padding: ${({ $hasToggle }) => ($hasToggle ? "14px 84px 14px 16px" : "14px 16px")};
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: var(--auth-placeholder);
  }

  &:focus {
    border-color: var(--auth-accent);
    box-shadow: 0 0 0 3px rgba(242, 99, 38, 0.14);
  }
`;

export const ToggleButton = styled.button`
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #9a9288;
  padding: 8px 10px;
  font-family: inherit;

  &:hover {
    color: var(--auth-text-secondary);
  }
`;

export const ErrorMessage = styled.span`
  min-height: 18px;
  margin-top: 6px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--auth-accent);
`;
